// libs
import React, {useEffect, useState, useMemo} from 'react';
import {useTranslation} from "react-i18next";
import axios from "../../../../axios-defaults";

// hoc
import Aux from '../../../../hoc/Auxiliary';

// components
import TanksList from "../../../Tanks/TanksList";

const Tanks = (props) => {
    const {subAccountCode, subAccount} = props;
    const {t, i18n} = useTranslation();

	// State Management ////////////////////////////////////////////////////
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const getTanks = async () => {
		setLoading(true);
        await axios.get(`/subAccounts/tanks?subAccountCode=${subAccountCode}`)
            .then(response => {
				setLoading(false);
                if (response.data.succeeded) {
                    setItems(response.data.data);
                }
            }).catch(error => {
                console.log('[Tanks.js] : ajax error in getTanks()', error.message)
				setLoading(false);
            });
    }

    useEffect( () => {
		getTanks();
    }, []);

    return (
        <Aux>
            <h2 className="headline headline--section headline--uppercase">{t('tabs.tanks')}</h2>
			<TanksList initialData={ items }
					   subAccount={ subAccount }
					   reloadData={ () => { getTanks(); } }
					   loading={loading}
					   refreshTabs={ (props.hasOwnProperty('refreshTabs')) ? props.refreshTabs : null }
					   changeDateFilter={ (props.hasOwnProperty('changeDateFilter')) ? props.changeDateFilter : null } />
        </Aux>
    );
}

export default Tanks;
